export default Object.assign({}, {
	STATUS_NEW: 'new',
	STATUS_CLIENT_NOT_ANSWER: 'client_not_answer',
	STATUS_ARCHIVE: 'archive',
	STATUS_PROCESSING: 'processing',
	STATUS_OFFER_SENT: 'offer_sent',
	STATUS_WORK_LONGTERM: 'work_long_term',
	STATUS_WAITING_PAYMENT: 'waiting_payment',
	STATUS_WAITING_AUTHOR: 'waiting_author',
	STATUS_IN_PROGRESS: 'in_progress',
	STATUS_WAITING_APPROVE: 'waiting_approve',
	STATUS_COMPLETED: 'completed',
	STATUS_FAILED: 'failed',
	STATUS_FAILED_WITH_PAYOUT: 'failed_with_payout',
	STATUS_DELETED: 'deleted',
})
